import { render, staticRenderFns } from "./exportScale.vue?vue&type=template&id=2290961a&scoped=true"
import script from "./exportScale.vue?vue&type=script&lang=js"
export * from "./exportScale.vue?vue&type=script&lang=js"
import style0 from "./exportScale.vue?vue&type=style&index=0&id=2290961a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2290961a",
  null
  
)

export default component.exports